<template>
    <div class="light-box" @click="closeBox" @keydown="keyDown">
        <div class="light-box-content">
            <div class="light-box-bottoms">
                <ul>
                    <li>
                        <a href="#" @click.prevent="closeBox(event, true)">
                            &times;
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="prevPic">
                            &rtrif;
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="nextPic">
                            &ltrif;
                        </a>
                    </li>
                </ul>
            </div>
            <div class="light-box-pic">
                <img v-if="picture" :src="picture">
            </div>
        </div>


    </div>
</template>

<script setup>

import { defineEmits } from 'vue'

const props = defineProps([ "picture", "title" ])
const emits = defineEmits([ "close", "next", "previous" ])

function closeBox($e, flag = false) {
    if (flag || $e.target.nodeName == 'DIV') {
        emits('close')
    }
}

function keyDown($e) {
    if ($e.code == 'ArrowRight') {
        nextPic($e)
        // console.log('right')
    } else if ($e.code == 'ArrowLeft') {
        prevPic($e)
        // console.log('left')
    } else {
        // console.log('nothing')
    }
}

function nextPic($e) {
    emits('next')
}

function prevPic($e) {
    emits('previous')
}

</script>

<style lang="less" scoped>
    
    .light-box {
        position: fixed;
        z-index: 1000;

        img {
            position: fixed;
            height: auto;
            width: auto;
            max-width: 80vw;
            max-height: 70vh;
            top:0;right:0;bottom:0;left:0;
            margin: auto;
            user-select: none;
        }
    }

</style>